// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"f96ab9c545698a43ae78","339":"3f25a242b7e474a088e3"}[chunkId] + ".js";
};